const ListIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M.875006.24998L13.125.249981c.4833 0 .875.391768.875.875009C14 1.60823 13.6083 2 13.125 2H.874975C.391736 2-.00003 1.60823-.00003 1.12499 0 .641748.391737.24998.875006.24998zM.875006 4.62502H13.125c.4833 0 .875.39174.875.87498 0 .48323-.3917.875-.875.875H.874975c-.483239 0-.875005-.39174-.875005-.875 0-.48327.391767-.87498.875036-.87498zM.875006 8.99999H13.125c.4833 0 .875.39174.875.875 0 .48331-.3917.87501-.875.87501H.874975c-.483239 0-.875005-.3917-.875005-.87501 0-.48327.391767-.875.875036-.875z" fill="currentColor"/>
    </svg>
  )
}

export default ListIcon
